import React from "react"
import styled from "styled-components"
import Counter from "../atoms/counter"
import media from "styled-media-query"
import CounterText from "../atoms/counter-text"

const Wrap = styled.div`
  border-bottom: solid 1px #346ec1;
  color: #fff;
  display: flex;
  justify-content: space-between;
`
const StyledH1 = styled.h1`
  border-bottom: solid 1px #fff;
  font-family: "Teko", sans-serif;
  font-weight: 600;
  font-size: 20px;
  height: 28px;
  letter-spacing: 1.4px;
  margin: 8px 0 0 0;
  ${media.greaterThan("small")`
    font-size: 32px;
    letter-spacing: 2.2px;
    height: 40px;
    margin: 12px 0 0 0;
  `}
`
const StyledCounter = styled(Counter)`
  background-color: #f8ba12;
  border-radius: 5px 5px 0 0;
  color: #fff;
  line-height: 30px;
  letter-spacing: 1.7px;
  height: 30px;
  ${media.greaterThan("small")`
    height: 35px;
    line-height: 35px;
  `}
`

const RHeader = props => {
  const no = props.index + 1
  return (
    <Wrap>
      <StyledH1>GOAL!!</StyledH1>
      <StyledCounter>
        <CounterText>{no}/10</CounterText>
      </StyledCounter>
    </Wrap>
  )
}

export default RHeader
